import script from "./FlyoutSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyoutSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FlyoutSidebar.vue?vue&type=style&index=0&id=58d9ecf5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d9ecf5"]])

export default __exports__